import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  termsContainer: (theme: Theme): SerializedStyles => css`
    height: ${theme.mui.spacing(30)}px;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    border: 1px solid ${theme.mui.palette.divider};
    border-radius: ${theme.mui.shape.borderRadius}px;
  `,

  terms: (theme: Theme): SerializedStyles => css`
    height: 100%;
    width: 100%;
    border: none;
  `,
};

export default styles;
